import { styled } from "styled-components";

export const NumberPickerSectionWrapper = styled.div<{
  $altStyling?: boolean;
  $hasHeading?: boolean;
}>`
  width: 100%;
  display: flex;
  justify-content: center;
  background: ${({ theme, $altStyling, $hasHeading }) =>
    $altStyling
      ? `linear-gradient(to bottom, ${theme.colors.primary[950]} ${$hasHeading ? "300px" : "200px"}, ${theme.colors.base} 0)`
      : theme.colors.base};
  position: relative;
  overflow: hidden;
`;

export const NumberPickerHeader = styled.div<{ $altStyling?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${({ theme, $altStyling }) =>
    $altStyling ? theme.colors.base : "currentcolor"};
  width: 100%;
  gap: 12px;
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  padding-top: 48px;
`;

export const NumberPickerSectionContainer = styled.div`
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  width: 100%;
`;

export const Arch = styled.div`
  z-index: 0;
  color: ${({ theme }) => theme.colors.base};
  overflow-x: hidden;
  position: absolute;
  top: 100px;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: -1px;

  @media (min-width: 2400px) {
    display: none;
  }
`;
